module.exports = __webpack_public_path__ + "static/media/SarahSwitek_14_ActivitiesConclusion_4.a336f820.mp3";